(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .factory('FormEventActions', FormEventActions);

    function FormEventActions($injector, lodash, TextHelper, GenericModel, notifier, ButtonRegistry, ActionCommon, $q, RequestHelper) {
        return function (originFormIdentification, actions, element, elementValue) {

            run(actions);

            function run(_actions) {
                angular.forEach(_actions, function (action, actionName) {
                    actionCtrl(actionName, action, getFormBuilderService(action));
                });
            }

            function getFormBuilderService(action) {
                var formIdentifier = lodash.get(action, 'form_name', originFormIdentification);
                var FormBuilderService = $injector.get('FormBuilderService');
                return FormBuilderService.get(formIdentifier);
            }

            function actionCtrl(actionName, action, fbService) {
//                var actionPromise = $q.defer();
                var functionMap = {
                    send_request: send_request,
                    validate: validate,
                    append_html: append_html,
                    clear_html: clear_html,
                    add_elements: add_elements,
                    append_model: append_model,
                    validation: validation,
                    show_loading: show_loading,
                    hide_loading: hide_loading,
                    show_element_loading: show_element_loading,
                    hide_element_loading: hide_element_loading,
                    show_element_icon: show_element_icon,
                    hide_element_icon: hide_element_icon,
                    call_event: call_event,
                    set_elements: set_elements,
                    update_element: update_element,
                    update_multiple_element: update_multiple_element,
                    set_buttons: set_buttons,
                    show_notification: ActionCommon.show_floating_notifier,
                    show_static_notification: ActionCommon.show_static_notifier,
                    append_view_events: append_view_events,
                    set_view_events: set_view_events,
                    remove_view_events: remove_view_events,
                    refresh_form_elements: refresh_form_elements,
                    set_model: set_model,
                    enable_button: enable_button,
                    disable_button: disable_button,
                    set_active: set_active,
                    remove_elements: remove_elements,
                    remove_buttons: remove_buttons
                };
                functionMap[actionName](action);

                function send_request() {
                    var modelData = {};
                    lodash.set(modelData, element.name, elementValue);

                    var model = new GenericModel(action.datasource.url);
                    var method = lodash.get(action.datasource, 'method', 'get');
                    //lodash.set(action.data, 'model', lodash.pick(fbService.model, action.data.needed));
                    lodash.set(action.data, 'model', RequestHelper.getNeeded(fbService.model, action.data.needed));
                    var request_data = {"data": action.data};
                    model[method]({}, request_data, function (res) {

                        fbService.validation = {};
                        runActions(res);
                    }, handleRequestError);
                }

                function clearLoadings() {
                    hide_loading();
                    hide_element_loading();
                }

                function runActions(res) {
                    if (lodash.has(res, 'actions')) {
                        run(res.actions);
                    }
                }

                function append_html() {
                    fbService.formResultTemplate = action.html;
                    fbService.formResultTemplateModel = action.htmlModel;
                    runActions(action);
                    // if(lodash.has(action,'view_event_action')){
                    //     var view_event_action = action.view_event_action.action;
                    //     action.view_events = action.view_event_action.view_events;
                    //     switch (view_event_action) {
                    //         case 'append':
                    //             append_view_events();
                    //             break;
                    //
                    //         case 'set':
                    //             set_view_events();
                    //             break;
                    //     }
                    // }
                    //
                    //
                    // if(lodash.has(action,'button_action')){
                    //     var button_action = action.button_action.action;
                    //     action.buttons = action.button_action.buttons;
                    //     switch (button_action) {
                    //         case 'set':
                    //             set_buttons();
                    //             break;
                    //     }
                    // }
                    // For reference to access anything in the formResultTemplateModel in the action.html:
                    // to access action.htmlModel.test
                    // in html, refer to vm.options.test
                }

                function clear_html() {
                    fbService.formResultTemplate = "";
                    fbService.formResultTemplateModel = {};
                }

                function refresh_form_elements() {
                    var refreshElements = angular.copy(fbService.fbData.elements);

                    if (lodash.has(action, 'type')) {
                        var field_names = lodash.get(action, 'field_names', []);
                        refreshElements = lodash.filter(refreshElements, function (elem) {
                            return (action.type === 'only') && lodash.indexOf(field_names, elem.name) >= 0;
                        });
                        angular.forEach(refreshElements, function (elem) {
                            var elemIndex = lodash.findIndex(fbService.elements, {name: elem.name});
                            fbService.elements.splice(elemIndex, 1);
                            fbService.elements.splice(elemIndex, 0, elem);
                        });
                    } else {
                        fbService.elements = refreshElements;
                    }
                }

                //todo function to refresh subform form elements

                function add_elements(type) {

                    var elements = [];
                    action[type].reduce(function (prev, curr) {
                        var elementInForm = lodash.find(fbService[type], function (element) {
                            return (element.name == curr.name);
                        });
                        if (!elementInForm) {
                            prev.push(curr);
                        }
                        return prev;
                    }, elements);
                    fbService[type] = lodash.sortBy(fbService[type].concat(elements), 'position');
                }

                function do_remove_elements(type) {
                    lodash.remove(fbService[type], function (item) {
                        var in_actions_elements = lodash.find(action[type], function (element) {
                            return element.name == item.name;
                        });
                        return (!in_actions_elements);
                    });
                }

                function set_elements() {
                    do_remove_elements('elements');
                    add_elements('elements');
                    runActions(action);
                }

                function remove_elements() {
                    do_remove_elements('elements');
                }

                function remove_buttons() {
                    do_remove_elements('buttons');
                }

                function set_buttons() {
                    do_remove_elements('buttons');
                    add_elements('buttons');
                }

                function append_model() {
                    const type = lodash.get(action, 'type', 'merge');
                    if (type === 'merge') {
                        angular[type](fbService.model, action.model);
                    } else {
                        lodash.forIn(action.model, function (value, index) {
                            lodash.set(fbService.model, index, value);
                        });
                    }
                    // angular.merge(fbService.model, action.model);
                }

                function validation(data) {
                    fbService.validation = data || {};
                    hide_loading();
                    hide_element_loading();
                }

                function validate() {
                    var model = new GenericModel(action.datasource.url);
                    var method = lodash.get(action.datasource, 'method', 'get');
                    var request_data = {"data": {"field_value": elementValue, "field_name": element.name}};
                    model[method]({}, request_data, function (res) {
                        fbService.validation = {};
                        runActions(res);
                    }, handleRequestError);
                }

                function show_loading() {
                    fbService.showLoading = true;
                }

                function hide_loading() {
                    fbService.showLoading = false;
                }

                function show_element_loading() {
                    element.wrapper_class = TextHelper.addText(element.wrapper_class || '', 'loading', ' ');
                }

                function hide_element_loading() {
                    element.wrapper_class = TextHelper.removeText(element.wrapper_class || '', 'loading');
                }

                function show_element_icon() {
                    element.wrapper_class = TextHelper.addText(element.wrapper_class || '', action.className, ' ');
                }

                function hide_element_icon() {
                    element.wrapper_class = TextHelper.removeText(element.wrapper_class || '', action.className);
                }

                function separate_view_events_from_dialog(events) {
                    var results = {
                        view_events: {},
                        dialog_events: {}
                    };

                    angular.forEach(events, function (event, index) {
                        if (index.indexOf('dialog') === 0) {
                            results.dialog_events[index] = event;
                        } else {
                            results.view_events[index] = event;
                        }
                    });
                    return results;
                }

                function append_view_events() {
                    var events = separate_view_events_from_dialog(action.view_events);

                    if (!lodash.isEmpty(events.dialog_events)) {
                        //fbService.currentScope.$parent.vm.options.view_events = angular.merge({}, fbService.currentScope.$parent.vm.options.view_events, events.dialog_events);
                        fbService.currentScope.$parent.vm.addEvents(events.dialog_events);
                    }

                    if (!lodash.isEmpty(events.view_events)) {
                        fbService.mainCtrlScope.mainService.addViewEvents(events.view_events);
                    }
                    // fbService.mainCtrlScope.mainService.updateViewEvents(action.view_events);
                }

                function set_view_events() {
                    var events = separate_view_events_from_dialog(action.view_events);

                    if (!lodash.isEmpty(events.dialog_events)) {
                        fbService.currentScope.$parent.vm.setEvents(events.dialog_events);
                    }

                    if (!lodash.isEmpty(events.view_events)) {
                        fbService.mainCtrlScope.mainService.setViewEvents(events.view_events);
                    }

                    // fbService.currentScope.$parent.vm.options.view_events  = action.view_events;
                    // fbService.currentScope.$parent.vm.initEvent();
                }

                function set_active() {
                    element.active = data.active;
                }

                // Todo: Potential to have bug. The view_events here might not be an object but an array of events name. Will handle it when we need it.
                function remove_view_events() {
                    var events = separate_view_events_from_dialog(action.view_events);

                    if (!lodash.isEmpty(events.dialog_events)) {
                        fbService.currentScope.$parent.vm.removeEvents(events.dialog_events);
                    }

                    if (!lodash.isEmpty(events.view_events)) {
                        fbService.mainCtrlScope.mainService.removeViewEvents(events.view_events);
                    }
                }

                function set_model() {
                    fbService.model = action.model;
                    lodash.set(fbService, 'fbData.model', action.model);
                }

                function call_event() {
                    var eventData = {
                        targetScope: {
                            name: fbService.formIdentifier
                        },
                        target: element,
                        event: null,
                        model: fbService.model,
                        formIdentifier: fbService.formIdentifier
                    };

                    fbService.currentScope.$emit(action.event, eventData);
                }

                function update_element() {
                    if (lodash.has(action, 'field_name')) {
                        fbService.elementsService.updateRenderedElements(action.field_name, action.data, lodash.get(action, 'rendered', true));
                    }
                }

                function update_multiple_element() {
                    if (Array.isArray(action.field_name)) {
                        var field_specific_data = lodash.get(action, 'field_specific_data', null);
                        action.field_name.forEach(function(field) {
                            fbService.elementsService.updateRenderedElements(field, action.data, lodash.get(action, 'rendered', true), field_specific_data);
                        });
                    }
                }

                function enable_button() {
                    ButtonRegistry.enableButtons(action.buttons);
                }

                function disable_button() {
                    ButtonRegistry.disableButtons(action.buttons);
                }

                function handleRequestError(res) {
                    switch (res.status) {
                        case 422:
                            fbService.validation = {};
                            runActions(res.data);
                            validation(res.data);
                            break;
                        case 404:
                        case 500:
                        default:
                            clearLoadings();
                            break;

                    }
                }
            }
        };
    }
})();
